import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityTraffic/img/1.avif';
import image2 from '@src/assets/images/solution/cityTraffic/img/2.avif';
import image3 from '@src/assets/images/solution/cityTraffic/img/3.avif';
import image4 from '@src/assets/images/solution/cityTraffic/img/4.avif';
import image5 from '@src/assets/images/solution/cityTraffic/img/5.avif';
import image6 from '@src/assets/images/solution/cityTraffic/img/6.avif';
import image7 from '@src/assets/images/solution/cityTraffic/img/7.avif';
import image8 from '@src/assets/images/solution/cityTraffic/img/8.avif';
import image9 from '@src/assets/images/solution/cityTraffic/img/9.avif';

export default {
  type: 'Giải pháp giao thông',

  banner: {
    title: 'Phân tích phương tiện dựa trên AI, quản lý bãi đỗ xe trạm dừng đường cao tốc một cách thông minh',
    desc: 'Camera PTZ AI nhận diện vị trí xe và biển số trong khu vực đỗ xe theo thời gian thực, giảm tắc nghẽn, nâng cao hiệu quả vận hành và cải thiện trải nghiệm khách hàng.',
  },

  video: {
    title: 'Tối ưu hóa vận hành và tiện ích với phân tích đỗ xe dựa trên AI',
    desc: 'Camera AI nhận diện vị trí xe và biển số theo thời gian thực, hiển thị ngay trạng thái khả dụng của bãi đỗ và liên kết với thông tin người dùng để vận hành thông minh.',
    play: video,
  },

  func: [
    {
      theme: 'Theo dõi phương tiện bằng AI và thích ứng môi trường',
      title: 'Giám sát chính xác khu vực rộng bằng camera PTZ',
      desc: 'Kết hợp nhiều camera PTZ lắp đặt trên tháp chiếu sáng để bao phủ toàn bộ bãi đỗ xe mà không bỏ sót điểm mù. Zoom cận cảnh những khu vực cần thiết để giám sát chính xác, theo dõi luồng đỗ xe và khu vực tắc nghẽn theo thời gian thực.',
      sub1: 'Theo dõi trạng thái theo thời gian thực',
      icon1: IconClockGray,
      sub2: 'Kết nối dữ liệu nhanh',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: 'Nâng cao hiệu suất mô hình AI bằng dữ liệu thực tế',
      desc: 'ORBRO sử dụng công nghệ tăng cường dữ liệu theo thời gian thực để nhanh chóng đào tạo mô hình nhận diện phù hợp với đặc điểm bãi đỗ. Tỷ lệ nhận diện tăng nhanh chỉ sau một thời gian ngắn lắp đặt.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Độ chính xác cao',
      icon2: IconRulerGray,
      image: image2,
    },
    {
      title: 'Nhận diện ổn định cả ban đêm và điều kiện ánh sáng yếu',
      desc: 'Nhờ thuật toán tối ưu cho ánh sáng yếu và phần cứng hỗ trợ NIR, các phương tiện di chuyển nhanh vẫn được nhận diện chính xác ngay cả vào ban đêm hoặc trong điều kiện ánh sáng kém.',
      sub1: 'Định danh tài sản nguy hiểm',
      icon1: IconWarningGray,
      sub2: 'Thiết lập phương án ứng phó',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: 'Duy trì hiệu suất ổn định trong điều kiện thời tiết khắc nghiệt',
      desc: 'Áp dụng thuật toán lọc dựa trên deep learning giúp hệ thống thích ứng với thay đổi thời tiết, duy trì khả năng theo dõi phương tiện ổn định ngay cả khi có mưa, tuyết hoặc điều kiện khí hậu phức tạp.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: 'Phân tích lưu lượng người trong không gian trong nhà',
      desc: 'Không gian trong nhà liền kề bãi đỗ xe được phân tích dòng người bằng camera mắt cá (Fisheye). Việc phân tích kết nối giữa khu vực đỗ xe và cửa hàng giúp tăng hiệu quả kinh doanh.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: 'Tự động hóa hiệu quả vận hành và phát hiện rủi ro',
      title: 'Phân tích lưu lượng xe ra/vào',
      desc: 'Tự động thu thập thống kê phương tiện tại các điểm ra/vào, dự báo mức độ tắc nghẽn theo khung giờ, cung cấp dữ liệu làm cơ sở để tối ưu hóa thời gian vận hành hoặc cải thiện cơ sở hạ tầng.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: 'Phát hiện và cảnh báo đi ngược chiều',
      desc: 'Khi xe di chuyển ngược hướng so với quy định, hệ thống sẽ phát cảnh báo ngay lập tức để xử lý kịp thời tình huống nguy hiểm.<br/><br/> • Phát hiện đối tượng di chuyển sai hướng trong khu vực quy định<br/><br/> • Có thể phát hiện đi ngược chiều ở lối ra của trạm dừng<br/><br/> • Cung cấp chức năng cảnh báo (liên kết ứng dụng di động, trung tâm giám sát)',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: 'Phân tích phương tiện đỗ lâu',
      desc: 'Phát hiện người đi bộ dừng lại lâu tại lối ra/vào có tốc độ di chuyển nhanh, phát cảnh báo để ngăn ngừa tai nạn. Đồng thời phân tích rủi ro tương tác giữa xe và người đi bộ.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: 'Tối ưu hóa hiệu suất và bảo mật quyền riêng tư với ROI video',
      desc: 'Thiết lập ROI (vùng quan tâm) để loại bỏ các phần hình ảnh không cần thiết. Điều này giúp tăng tốc độ xử lý và ẩn danh các khu vực nhạy cảm để bảo vệ quyền riêng tư.',
      sub1: 'Cung cấp dữ liệu thống kê',
      icon1: IconChartBarGray,
      sub2: 'Lưu trữ dữ liệu trên cloud',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: 'Các tính năng đa dạng',
    desc: 'Quản lý chất thải y tế yêu cầu sự giám sát liên tục. Một chút lơ là hoặc sai sót nhỏ cũng có thể dẫn đến tai nạn y tế nghiêm trọng. Do đó, cần quản lý chính xác và đảm bảo an toàn tuyệt đối.<br/>ORBRO cung cấp nhiều tính năng để xây dựng các cơ sở y tế an toàn và hiệu quả.',

    data: [
      { icon: IconBinocularsGray, title: 'PTZ theo dõi xe', desc: 'PTZ phóng to, theo dõi rộng.' },
      { icon: IconChartBarGray, title: 'Nhận diện AI', desc: 'Xe, người tự nhận diện.' },
      { icon: IconClockGray, title: 'Ban đêm/ánh sáng yếu', desc: 'Vẫn nhận ổn định ban đêm.' },
      { icon: IconChartBarGray, title: 'Chống thời tiết xấu', desc: 'Mưa tuyết vẫn theo dõi chuẩn.' },
      { icon: IconChartRadius, title: 'Phân tích người trong nhà', desc: 'Fish-eye hiển thị dòng người.' },
      { icon: IconRoute, title: 'Phân tích ra vào', desc: 'Thống kê lưu lượng xe.' },
      { icon: IconZoneGray, title: 'Bỏ vùng dư thừa (ROI)', desc: 'Giữ video cần thiết thôi.' },
      { icon: IconWarning, title: 'Báo ngược chiều', desc: 'Xe chạy sai hướng báo ngay.' },
      { icon: IconWarning, title: 'Cảnh báo người dừng lâu', desc: 'Người đứng lâu cảnh báo ngay.' },
      { icon: IconDashboard, title: 'Bảng AI trực quan', desc: 'Xem luồng & cảnh báo trực tiếp.' },
    ],
  },

  system: {
    title: 'Cấu hình hệ thống',
    img: rtlsSystem,
  },

  productTitle: 'Cấu hình sản phẩm',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'officeAsset' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
